import { Injectable }                                          from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '@environment/environment';


/**
 * Placeholder interceptor — previously injected JWT Authorization headers.
 * Authentication is now handled via HttpOnly cookies (withCredentials on each request).
 * This class is kept to avoid changes to the provider registration.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  intercept(
    request: HttpRequest<any>,
    next:    HttpHandler
  ): Observable<HttpEvent<any>> {
    const isApiRequest = request.url.includes('/api/v2') || request.url.includes('/api/v3') || request.url.includes(environment.cmApiUrl);
    if (isApiRequest) {
      return next.handle(request.clone({ withCredentials: true }));
    }
    return next.handle(request);
  }
}
